<div class="container-fluid notification ">
    <div class="d-flex">
        <div class="pr-0 profile-container-inner">
            <h3 class="semi-bold ml-3 pt-2">{{'MyNotifications' | translate}}</h3>
            <div class="mt-4 pro-details">

                <p class="pb-2 pt-2 text-left cursor d-flex align-items-center" [ngClass]="{'active-color': 0 === selectedIndexMenu}" (click)="redirectToNotify(0)">
                    <mat-icon routerLink="#" class="notify-icon cursor  mr-2" svgIcon="Message"></mat-icon> {{'Messages' | translate}}</p>
                <mat-divider class="my-2 ml-4 "></mat-divider>

                <p class="pb-2 pt-2 text-left cursor d-flex align-items-center" [ngClass]="{'active-color': 1 === selectedIndexMenu}" (click)="redirectToNotify(1)">
                    <mat-icon routerLink="#" class="notify-icon cursor  mr-2" svgIcon="Update"></mat-icon>
                    {{'Updates' | translate}}</p>
                <mat-divider class="my-2 ml-4 "></mat-divider>
                <p class="pb-2 pt-2 text-left cursor d-flex align-items-center" [ngClass]="{'active-color': 2 === selectedIndexMenu}" (click)="redirectToNotify(2)">
                    <mat-icon routerLink="#" class="notify-icon cursor  mr-2" svgIcon="Alert"></mat-icon> {{'Alerts' | translate}}</p>
                <mat-divider class="my-2 ml-4 "></mat-divider>

            </div>
        </div>
        <!-- Description Card -->
        <div class="w-100 pr-0 profile-page">
            <div class="row col-12 d-flex align-items-center justify-content-between m-0 pr-0">
                <h3 class="m-0 semi-bold">{{translate.instant(notifyTitle)}}</h3>
                <div class="float-right mt-3" (click)="closeNotification()">
                    <i class="material-icons close mb-2">
                        close
                    </i>
                </div>
            </div>
            <mat-card class="mb-3 alertmsg p-0">
                <mat-tab-group>
                    <mat-tab label="Profile details">
                        <div class="row">
                            <div class="mb-0 col-4 notification-card pr-0 app-alert pt-3 border-right">
                                <div class="row m-1">
                                    <div class="input-group mb-2 p-0 ml-2 mr-2">
                                        <input [(ngModel)]="searchWord" style="background: #fff !important" matInput class="form-control search-patient my-0 py-1 mdisplay"
                                            type="text" placeholder="{{'Search'| translate}}" aria-label="Search">
                                        <div class="input-group-append">
                                            <span class="input-group-text red lighten-3" id="basic-text1">
                                                <mat-icon *ngIf="!searchWord">search</mat-icon>
                                                <mat-icon *ngIf="searchWord" (click)="removeSearchText()" style="cursor: pointer">
                                                    close
                                                </mat-icon>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <mat-list class="border-top ml-2">
                                    <mat-list-item *ngFor="let source of dataSource | filter:searchWord; let i = index;" (click)="curMsgClick(source)" [ngClass]="{'menuactive': i === selectedIndex}">
                                        <p mat-line class="name-ellipsis"> {{source.title}}</p>
                                        <p mat-line class="small ml-3 text-height"> {{source?.createdOn | timeAgo}}
                                            <span class="divider-left ml-1"></span>
                                            <span class="view-text">{{source?.viewCount}} views
                                            </span>
                                        </p>

                                        <mat-divider></mat-divider>
                                    </mat-list-item>
                                </mat-list>
                                <div *ngIf="dataSource != undefined">
                                    <mat-card class="ml-2" *ngIf="(dataSource !== null && (dataSource | filter: searchWord).length === 0 && searchWord !== null && searchWord !== '')">
                                        {{'Nomatches' | translate}}</mat-card>
                                    <mat-card *ngIf="dataSource.length === 0">{{'You have no new' | translate}} {{noMsg}}</mat-card>
                                </div>
                            </div>

                            <div class="col-8 common-card-container float-right w-100 my-3 p-0">
                                <div class="container-fluid pl-0">
                                    <div class="border-bottom  pb-3 d-flex align-items-center">
                                        <div class="row ml-2 col-12">
                                            <div class="col-md-12">
                                                <h4 class="m-0  pb-1 semi-bold">{{curMsg?.title}}</h4>
                                                <div class="small-text"> {{curMsg?.createdOn | date:'medium'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="description-text mt-2">
                                        <div [innerHtml]="sanitize(curMsg?.messageDescription)"></div>
                                    </div>
                                    <!--  -->
                                    <div class="form-group mt-3" *ngIf="curMsg?.assetPath">
                                        <div class="cursor text-center attachment">
                                            <video controls class="video-container" *ngIf="curMsg?.fileType=='Video'">
                                                <source [src]="envLink+curMsg?.newAssetPath" type="video/mp4">
                                            </video>
                                            <img class="img-container" *ngIf="curMsg?.fileType=='Image'" [src]="envLink+curMsg?.newAssetPath" [alt]="curMsg?.assetName">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="message">
                        <h1>test</h1>
                    </mat-tab>
                    <mat-tab label="updates">
                        <h1>test2</h1>
                    </mat-tab>
                </mat-tab-group>
            </mat-card>
        </div>
    </div>
</div>